import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useTranslation } from "react-i18next";
import CartProduct from "../../components/cart/cartProduct";
import { Typography } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const CartScreen = ({ storesData, productsData, styles, totals }) => {
  const { i18n, t } = useTranslation();

  const RenderRowItem = ({ row, index }) => {
    const storesIDs = row?.priceList.map((data) => data.storeInfo.id);
    const storesDetails = storesData.slice(0, 5);
    const priceList = row?.priceList;
    return (
      <>
        <StyledTableCell component={"th"} scope={"row"}>
          <CartProduct
            index={index}
            productItem={row}
            language={i18n.language}
          />
        </StyledTableCell>
        {priceList && !!priceList.length && priceList.length > 0
          ? priceList.slice(0, 3).map((item, i) => {
              if (item === null) {
                return (
                  <StyledTableCell align="center">
                    <Typography
                      style={{
                        fontSize: 13,
                        color: "black",
                        fontWeight: "bold",
                      }}
                    >
                      {"Not Available"}
                    </Typography>
                  </StyledTableCell>
                );
              } else {
                const price =
                  !!item && !!item.price ? item.price * row.cartQuantity : 0;
                return (
                  <StyledTableCell align="center">
                    {!!item.storeInfo.image && (
                      <div className={styles.images}>
                        <img
                          src={item.storeInfo.image}
                          className={styles.images}
                        />
                      </div>
                    )}
                    <div className={styles.info}>
                      <Typography
                        className={styles.infoText}
                        style={{
                          fontSize: 13,
                          color: !price || price === 0 ? "black" : "green",
                          fontWeight: "bold",
                        }}
                      >
                        {!price || price === 0 ? "Not Available" : price}
                        {!!price && price > 0 && (
                          <Typography
                            style={{ color: "green", fontWeight: "bold" }}
                          >
                            {t("product.currency")}
                          </Typography>
                        )}
                      </Typography>
                    </div>
                  </StyledTableCell>
                );
              }
            })
          : [0, 1, 2].map((item, i) => {
              return (
                <StyledTableCell align="center">
                  <Typography
                    className={styles.infoText}
                    style={{
                      fontSize: 13,
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    {"Not Available"}
                  </Typography>
                </StyledTableCell>
              );
            })}
        {(() => {
          if (
            priceList &&
            !!priceList.length &&
            priceList.length > 0 &&
            priceList.slice(0, 3).length < 3
          ) {
            let missingList = [];
            const missing = 3 - priceList.slice(0, 3).length;
            for (let i = 0; i < missing; i++) {
              missingList.push(0);
            }
            return missingList.map((item, i) => (
              <StyledTableCell align="center">
                <div className={styles.info} key={i + "item"}>
                  <Typography
                    className={styles.infoText}
                    style={{
                      fontSize: 13,
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    {"Not Available"}
                  </Typography>
                </div>
              </StyledTableCell>
            ));
          }
        })()}
        {storesData && !!storesDetails.length && storesDetails.length > 0 && (
          <>
            {(() => {
              return storesDetails.map((item, i) => {
                const price =
                  row.priceList.find((price) => price.storeInfo.id == item.id)
                    ?.price ?? 0;
                return (
                  <StyledTableCell align="center">
                    <div className={styles.info}>
                      <Typography
                        className={styles.infoText}
                        style={{
                          fontSize: 13,
                          color: !price || price === 0 ? "black" : "green",
                          fontWeight: "bold",
                        }}
                      >
                        {!price || price === 0
                          ? "Not Available"
                          : price * row.cartQuantity}

                        {!!price && price > 0 && (
                          <Typography
                            style={{
                              fontSize: 13,
                              color: "green",
                              fontWeight: "bold",
                            }}
                          >
                            {t("product.currency")}
                          </Typography>
                        )}
                      </Typography>
                    </div>
                  </StyledTableCell>
                );
              });
            })()}
          </>
        )}
      </>
    );
  };

  const RenderTotalRow = ({}) => {
    const initTotals =
      storesData && storesData.length && storesData.length > 0
        ? Array(3 + storesData.slice(0, 5).length).fill(0)
        : totals;
    let total = initTotals.map((item) => {
      return { price: item, storeInfo: null, totalUnAvailable: 0 };
    });
    if (productsData) {
      productsData.forEach((product) => {
        const storesIDs = product.priceList.map((data) => data.storeInfo.id);
        const storesDetails = storesData.slice(0, 5);
        const priceList = product.priceList;
        if (priceList && !!priceList.length && priceList.length > 0) {
          priceList.slice(0, 3).forEach((item, i) => {
            const price =
              !!item && !!item.price ? item.price * product.cartQuantity : 0;
            const totalPrice = total[i].price + price;
            const storeInfo = item.storeInfo ?? null;
            total[i] = {
              price: totalPrice,
              storeInfo: storeInfo,
              totalUnAvailable: 0,
            };
          });
        }
        if (storesData && !!storesDetails.length && storesDetails.length > 0) {
          storesDetails.forEach((item, i) => {
            const price =
              product?.priceList?.find((price) => price.storeInfo.id == item.id)
                ?.price ?? 0;
            const totalPrice =
              total[i + 3].price + price * product.cartQuantity;
            const unAvailable = product?.priceList[0]?.price ?? 0;
            const totalUnAvilable =
              total[i + 3].totalUnAvilable + unAvailable * product.cartQuantity;
            const storeInfo = item.storeInfo ?? null;
            total[i + 3] = {
              price: totalPrice,
              storeInfo: storeInfo,
              totalUnAvailable: totalUnAvilable,
            };
          });
        }
      });
      const lowestToHighest =
        total
          .filter((item) => item.price > 0)
          .sort(function (a, b) {
            return (
              a.price + a.totalUnAvailable - (b.price + b.totalUnAvailable)
            );
          }) ?? [];
      return (
        <>
          <StyledTableCell align="center">
            <Typography
              style={{
                fontSize: 17,
                textAlign: "center",
                paddingTop: 10,
                paddingBottom: 10,
                width: "100%",
              }}
            >
              {" "}
              Total
            </Typography>
          </StyledTableCell>

          {total &&
            !!total.length &&
            total.length > 0 &&
            total.map((item, i) => {
              return (
                <StyledTableCell align="center">
                  <div className={styles.info}>
                    <Typography
                      className={styles.infoText}
                      style={{ color: "green", fontWeight: "bold" }}
                    >
                      {item.price}
                      <Typography
                        style={{ color: "green", fontWeight: "bold" }}
                      >
                        {t("product.currency")}
                      </Typography>
                    </Typography>
                  </div>
                </StyledTableCell>
              );
            })}
        </>
      );
    } else {
      return (
        <>
          <StyledTableCell align="center">
            <Typography style={{ fontSize: 17, textAlign: "center" }}>
              {" "}
              Total
            </Typography>
          </StyledTableCell>
          {initTotals &&
            !!initTotals.length &&
            initTotals.length > 0 &&
            initTotals.map((price, i) => {
              return (
                <StyledTableCell align="center">
                  <div className={styles.info}>
                    <Typography
                      className={styles.infoText}
                      style={{ color: "green", fontWeight: "bold" }}
                    >
                      {price}
                      <Typography
                        style={{ color: "green", fontWeight: "bold" }}
                      >
                        {t("product.currency")}
                      </Typography>
                    </Typography>
                  </div>
                </StyledTableCell>
              );
            })}
        </>
      );
    }
  };

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 800 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Products List</StyledTableCell>
            <StyledTableCell align="center">Lowest Price</StyledTableCell>
            <StyledTableCell align="center">2nd Lowest Price</StyledTableCell>
            <StyledTableCell align="center">3rd Lowest Price</StyledTableCell>
            {!!storesData &&
              !!storesData.length &&
              storesData.length > 0 &&
              storesData
                .slice(0, 5)
                .map((store, index) => (
                  <StyledTableCell align="center">
                    {i18n.language == "ar" ? store.nameAr : store.nameEn}
                  </StyledTableCell>
                ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {productsData.map((row, index) => (
            <StyledTableRow key={row.id}>
              <RenderRowItem row={row} index={index} />
            </StyledTableRow>
          ))}
          <StyledTableRow key={"total"}>
            <RenderTotalRow />
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CartScreen;
